import useGlobalStore from '@/store/useGlobalStore'
import { en } from '@/components/_forms/_helpers/Components/CountrySelector/localization/en.json'
import { es } from '@/components/_forms/_helpers/Components/CountrySelector/localization/es.json'
import { de } from '@/components/_forms/_helpers/Components/CountrySelector/localization/de.json'
import { fr } from '@/components/_forms/_helpers/Components/CountrySelector/localization/fr.json'
import { it } from '@/components/_forms/_helpers/Components/CountrySelector/localization/it.json'
import { nl } from '@/components/_forms/_helpers/Components/CountrySelector/localization/nl.json'
import { ar } from '@/components/_forms/_helpers/Components/CountrySelector/localization/ar.json'

const locales: Record<string, Record<string, string>> = {
  en,
  es,
  de,
  fr,
  it,
  nl,
  ar,
}

export const useCountryLocalization = () => {
  const {
    app: { language },
  } = useGlobalStore()

  const getCountryName = (code: string, langOverride?: string): string => {
    const lang = langOverride || language || 'en'
    const locale = locales[lang] || locales.en
    return locale[code] || code
  }

  return { getCountryName }
}
